export default __webpack_public_path__ + "static/media/bbq.f3b84e1a.svg";